export const locationsMapped: { [key: string]: string } = {
  'Bologna, Metropolitan City of Bologna, Italy': 'Bologna, Italy',
  'Rome, Metropolitan City of Rome, Italy': 'Rome, Italy',
  'Milano, Metropolitan City of Milan, Italy': 'Milan, Italy',
  'Kraków, Poland': 'Krakow, Poland',
  'Turin, Metropolitan City of Turin, Italy': 'Turin, Turin, Italy',
};
